import { useLayoutEffect, useRef } from 'react'

import { OnChangePlugin } from '@lexical/react/LexicalOnChangePlugin'
import { useDebounceFn } from 'ahooks'
import { EditorState } from 'lexical'

import { useEditor } from '../../hooks/useEditor'

import { StatePluginProps } from './interface'

export const StatePlugin = ({ value, onChange }: StatePluginProps) => {
  const editor = useEditor()
  const updatedRef = useRef(false)

  useLayoutEffect(() => {
    if (!updatedRef.current && value) {
      editor.update(() => {
        const state = editor.parseEditorState(value)
        if (!state.isEmpty()) {
          editor.setEditorState(state)
        }
      })
    }
  }, [editor, value])

  const { run: handleChange } = useDebounceFn(
    (state: EditorState) => {
      updatedRef.current = true
      onChange?.(JSON.stringify(state.toJSON()))
    },
    {
      trailing: true,
      wait: 500
    }
  )

  return (
    <OnChangePlugin
      ignoreHistoryMergeTagChange
      ignoreSelectionChange
      onChange={handleChange}
    />
  )
}
